var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { storageRef } from 'data/firestoreClient';
import { FileResult } from 'models/files/fileResult';
import { injectable } from 'inversify';
var StorageService = /** @class */ (function () {
    function StorageService() {
        /**
         * Upload image on the server
         * @param {file} file
         * @param {string} fileName
         */
        this.uploadFile = function (file, fileName, progress) {
            return new Promise(function (resolve, reject) {
                // Create a storage refrence
                // HRMMM file location
                var storageFile = storageRef.child("Models/" + fileName);
                // Upload file
                var task = storageFile.put(file);
                task.then(function (result) {
                    result.ref.getDownloadURL()
                        .then(function (downloadURL) {
                        resolve(new FileResult(downloadURL, result.metadata.fullPath));
                    })
                        .catch(function (error) {
                        reject(error);
                    });
                }).catch(function (error) {
                    reject(error);
                });
                // Upload storage bar
                task.on('state_changed', function (snapshot) {
                    var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    progress(percentage, true);
                }, function (error) {
                    console.log('========== Upload Image ============');
                    console.log(error);
                    console.log('====================================');
                }, function () {
                    progress(100, false);
                });
            });
        };
    }
    StorageService = __decorate([
        injectable()
    ], StorageService);
    return StorageService;
}());
export { StorageService };



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/services/files/StorageService.ts
// module id = 307
// module chunks = 50